import Roles from "../views/Roles.vue";
import Users from "../views/Users";
import UserCard from "../views/UserCard";
import RouteCard from "../views/RouteCard";
import Routes from "../views/Routes";
import RoleCard from "../views/RoleCard";
import DictionaryItems from "../views/DictionaryItems";
import DictionaryItemCard from "../views/DictionaryItemCard";
import OrganizationsAdmin from "../views/OrganizationsAdmin";
import OrganizationAdminCard from "../views/OrganizationAdminCard";
import Log from "../views/Log";
import Polls from "../views/Polls";
import PollCard from "../views/PollCard";
import usersWrapper from "@/modules/admin/views/usersWrapper";
import organizationWrapper from "@/modules/admin/views/organizationWrapper";
import routesWrapper from "@/modules/admin/views/routesWrapper";
import pollWrapper from "@/modules/admin/views/pollWrapper";

import adminWrapper from "@/modules/admin/components/adminWrapper";
import DictionaryWrapper from "@/modules/admin/views/dictionaryWrapper";
import Content from "@/views/Content";
// import store from '@/store/index'

export const routes = [
  {
    path: "/admin",
    name: "admin",
    component: Content,
    children: [
      {
        path: "users",
        name: "userWrapper",
        component: usersWrapper,
        children: [
          {
            path: "",
            name: "Users",
            component: Users
          },
          {
            path: ":action/:id",
            name: "userCard",
            component: UserCard
          }
        ]
      },
      {
        path: "roles",
        name: "adminWrapp",
        component: adminWrapper,
        children: [
          {
            path: "",
            name: "Roles",
            component: Roles
          },
          {
            path: ":action/:id",
            name: "roleCard",
            component: RoleCard
          }
        ]
      },
      {
        path: "/admin/routes",
        name: "routesWrapper",
        component: routesWrapper,
        children: [
          {
            path: "/admin/routes",
            name: "Routes",
            component: Routes
          },
          {
            path: "/admin/route/:action/:id",
            name: "routeCard",
            component: RouteCard
          }
        ]
      },
      {
        path: "dictionary/:name",
        name: "dictionaryWrapper",
        component: DictionaryWrapper,
        children: [
          {
            path: "",
            name: "dictionaryItems",
            component: DictionaryItems
          },
          {
            path: ":action/:id",
            name: "dictionaryItemCard",
            component: DictionaryItemCard
          }
        ]
      },
      {
        path: "organizations",
        name: "organizationWrapp",
        component: organizationWrapper,
        children: [
          {
            path: "",
            name: "OrganizationsAdmin",
            component: OrganizationsAdmin
          },
          {
            path: "edit/:id",
            name: "editOrganizationAdmin",
            component: OrganizationAdminCard
          }
        ]
      },
      {
        path: "/admin/poll",
        name: "pollWrapper",
        component: pollWrapper,
        children: [
          {
            path: "/admin/poll",
            name: "Poll",
            component: Polls
          },
          {
            path: "/admin/poll/:action/:id",
            name: "PollCard",
            component: PollCard
          }
        ]
      },
      {
        path: "/admin/log",
        name: "Log",
        component: Log
      }
    ]
  }
];
